document.addEventListener("DOMContentLoaded", () => {
  // Footer submenu expansion for viewport size<=450px
  const allSubmenuItems = document.querySelectorAll(".footer-submenu");
  allSubmenuItems.forEach((subMenuItem) => {
    const subMenuTitleContainer = subMenuItem.querySelector(
      ".submenu-title-container"
    );
    subMenuTitleContainer.addEventListener("click", function () {
      allSubmenuItems.forEach((item) => {
        if (item !== subMenuItem) {
          item.classList.remove("expanded-footer-submenu");
        }
      });
      //toggle expanded class in clicked menu item

      if (subMenuItem.classList.contains("expanded-footer-submenu")) {
        subMenuItem.classList.remove("expanded-footer-submenu");
      } else {
        subMenuItem.classList.add("expanded-footer-submenu");
      }
    });
  });
});
